import { Component,Inject } from '@angular/core';
import { FormControl,FormGroup } from '@angular/forms';
import {
MatLegacyDialogConfig as MatDialogConfig,
MatLegacyDialogRef as MatDialogRef,
MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA
} from '@angular/material/legacy-dialog';

import { Moment } from 'moment';
import { appMatDialogDefaultConfig } from '../../../helper/helper';
import { CustomLabelService } from '../../../services/custom-label/custom-label.service';
export type CommissionCsvExportDialogData = undefined | {
    onExport: (filter: { FromDate: Moment; ToDate: Moment }) => void;
}
export type CommissionCsvExportDialogReturnData = void | {
    FromDate: Moment | null,
    ToDate: Moment | null,
}

@Component({
    selector: 'app-commission-csv-export-dialog',
    templateUrl: './commission-csv-export-dialog.component.html',
    styleUrls: ['./commission-csv-export-dialog.component.scss'],
})
export class CommissionCsvExportDialogComponent {
    public static readonly DefaultConfig: MatDialogConfig = {
        ...appMatDialogDefaultConfig,
        maxWidth: '100%',
        width: '50%',
        minWidth: '600px',
        maxHeight: 'calc(100vh - 3.5rem)',
    };
    public Form = new FormGroup({
        FromDate: new FormControl<Moment>(null),
        ToDate: new FormControl<Moment>(null),
    });

    constructor(@Inject(MAT_DIALOG_DATA) public data: CommissionCsvExportDialogData, private dialogRef: MatDialogRef<CommissionCsvExportDialogComponent, CommissionCsvExportDialogReturnData>, protected cls: CustomLabelService) {}

    Export() {
        if (this.Form.invalid) {
            return;
        }

        this.dialogRef.close({
            FromDate: this.Form.controls.FromDate.value,
            ToDate: this.Form.controls.ToDate.value,
        });
    }
}
